import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => {
  const handleClick = () => {
    window.open('https://wa.me/5562996951404', '_blank');
  };

  return (
    <div 
      className="whatsapp-float" 
      onClick={handleClick}
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="w-8 h-8 text-white" />
    </div>
  );
};

export default WhatsAppFloat;
